<script lang="ts" setup>
import { PropType, ref,computed } from 'vue'
import { ChatMessage } from '../../typings'
import TextLoading from '@/views/components/TextLoading.vue'
import ReferenceItem from '@/views/components/ReferenceItem.vue'
import CmdSuggestion from '@/views/components/CmdSuggestion.vue'
import { createNewFeedback } from '@/api/chat-session'
import { useStore } from 'vuex';
const store = useStore();
const token = computed(() => store.state.token);
//import MarkdownEditor from 'vue-markdown-editor'
//import { MdPreview } from 'md-editor-v3'
//import 'md-editor-v3/lib/preview.css'

// message：接受消息对象，展示消息内容和头像，并且根据角色调整消息位置。
const props = defineProps({
  conversationGuid: { type: String ,deault: true ,required: true},
  message: { type: Object as PropType<ChatMessage>, required: true },
  senMessageEnable: { type: Boolean ,deault: true ,required: true},
  isLastMessage: { type: Boolean ,deault: true ,required: true},
  suggestionStatus: { type: Boolean ,deault: true ,required: true},
})

const emit = defineEmits<{
  executeSg: [command: String],
  closeSg:any
}>()

const showSuggestion = ref(true);

const handleExcuteSuggestion = () =>{
  showSuggestion.value = false;
  emit('executeSg',props.message.command.name);
}

const handleCloseSuggestion = () =>{
  showSuggestion.value = false;
}

const convertNewlines=(text:String)=>{
      return text.replace(/\n/g, '\n');
    }

const bCopied = ref(false);
const bClickedLike = ref(false);
const bclickedDislike = ref(false);
// 获取 tooltip 的 ref
const copyTooltipRef = ref<any>(null);
const copyTooltipVisible = ref(false);
//复制
const copyMessage = () =>{
  navigator.clipboard.writeText(props.message.content).then(() => {
    bCopied.value = true;
    copyTooltipVisible.value = false; 
    setTimeout(() => {
      bCopied.value = false;
    }, 2000);
  }).catch(err => {
    console.error('Failed to copy text to clipboard:', err);
  });
  
  }  
//点赞
const likeResponse = async () =>{
    if(!bClickedLike.value && !bclickedDislike.value)
    {
      createNewFeedback(props.conversationGuid, props.message.guid, 1, token.value).then(
        (res)=>
        {
          if(undefined == res)
          {
            return;
          }
          
          bClickedLike.value = true;
        }
      )

    }
}    
//点踩
const dislikeResponse = () =>{
  if(!bClickedLike.value && !bclickedDislike.value)
    {
      createNewFeedback(props.conversationGuid, props.message.guid, 2, token.value).then(
        (res)=>
        {
          if(undefined == res)
          {
            return;
          }
          
        bclickedDislike.value = true;
        }
      )
    }
  }   
</script>

<!-- 整个div是用来调整内部消息的位置，每条消息占的空间都是一整行 -->
<template>
  <div class="message-row">
    <!-- 消息展示，当历史消息中存在空消息时，不显示空消息 -->
    <div class="row" v-if="message.content || !message.content && !senMessageEnable">
      <!-- 头像， -->
      <div class="avatar-wrapper">
        <div v-if="message.role === 'user'" >
          <i class="el-icon-user">
            <span class="icon-content">content</span>
          </i>
        </div>
        <div v-else >
          <i class="el-icon-assistant">
            <span class="icon-content">content</span>
          </i>
        </div>
      </div>
      <!-- 发送的消息 -->
      <div v-if="message.role === 'user'" class="message">
        <!-- 预览模式，用来展示markdown格式的消息 -->
        <v-md-preview 
          class="md-preview"
          :text="message.content"
        ></v-md-preview >
      </div>
      <!-- 回复的消息 -->
      <div v-else class="message" >
        <div class="assistant-message-wrapper">
          <v-md-preview 
            v-if="message.content"
            class="md-preview"
            :text="convertNewlines(message.content)"
          >
          </v-md-preview >
          <!-- 如果消息的内容为空则显示加载动画 -->
          <TextLoading v-else-if="isLastMessage && !message.content"></TextLoading>
          <!--<div v-if="message.References.length > 0" class="reference">-->
          <div class="referenceWrapper">
            <ReferenceItem
            v-for="(reference, index) in message.references"
            :index="index"
            :reference="reference"
            ></ReferenceItem>
          </div>
        </div>
        <div   class="extra-button-wrapper">
          <!-- Here you add your buttons -->
          <v-row>
            <v-col cols="auto">
              <el-tooltip v-model="copyTooltipVisible" :content="$t('messageRow.copy')" placement="bottom" :open-delay="500" :hide-after="0" >
                <el-button class="extra-button" icon="el-icon-copy" @click="copyMessage">
                  <i :class="bCopied?  'el-icon-copied':'el-icon-copy'">
                  </i>
                </el-button>
              </el-tooltip>
              
            </v-col>
            <v-col cols="auto">
              <el-tooltip :content="$t('messageRow.good')" placement="bottom" :open-delay="500" :hide-after="0">
                <el-button class="extra-button"  @click="likeResponse" >
                  <i :class="bClickedLike ? 'el-icon-good-fill' : 'el-icon-good'">
                  </i>
                </el-button>
              </el-tooltip>
            </v-col>
            <v-col cols="auto">
              <el-tooltip :content="$t('messageRow.bad')" placement="bottom" :open-delay="500" :hide-after="0">
                <el-button class="extra-button"  @click="dislikeResponse">
                  <i :class="bclickedDislike ? 'el-icon-bad-fill' : 'el-icon-bad'">
                  </i>
                </el-button>
              </el-tooltip>
            </v-col>
          </v-row>
        </div>
        <!-- <div v-if="showSuggestion && suggestionStatus && senMessageEnable && message.command.name" class="cmd-suggestion-warpper">
        <CmdSuggestion :command="message.command.name" @executeSg="handleExcuteSuggestion" @closeSg="handleCloseSuggestion" ></CmdSuggestion>
        </div> -->
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import "@/style/_handle.scss";

.message-row 
{
  //display: flex;
  display: grid;
  grid-template-columns: 1fr auto; 

  // 靠左边显示
  .row 
  {
    display: flex;
    flex-direction: row;
    .avatar-wrapper 
    {
      height:100%;
      
      .el-icon-assistant
      {
        display: flex;
        width:36px;
        height:36px;
        @include background_image("assistant-img");
        background-size:contain;
      }

      .el-icon-user
      {
        display: flex;
        width:36px;
        height:36px;
        @include background_image("user-img");
        background-size:contain;
      }

      .icon-content
      {
        visibility: hidden;
      }
    }

    .message 
    {
      font-size: 15px;
      margin-left: 20px;
      margin-bottom: 40px;
      position: relative;
      //justify-content: flex-end; /* 子控件靠右对齐 */

      width: 100%; 
    }

    .assistant-message-wrapper
    {
      //max-width: 100%; 
      max-width: 1000px;
      min-width: 500px; 
      overflow-x: auto;
      border-radius: 10px;
      padding-bottom: 10px;
      @include background_color("dialogue-box");

      .referenceWrapper
      {
        max-width: 100%; 
        margin-left: 20px;
        margin-right: 10px;
        font-size: 12px;
      }
    }
    &:hover{
      .extra-button-wrapper{
        opacity: 1;
      }
    }
    .extra-button-wrapper
    {
      @include background_color("dialogue-background");
      justify-content: flex-start; /* 左对齐 */
      width: 72px; /* 3个按钮的宽度 (16px each) */
      border: 0px solid;
      //@include border_color("dialogue-box");
      border-radius: 5px;
      margin-top: 10px; /* 向下移动 */
      //visibility: hidden;
      transition: visibility 0.3s;
      //未悬停时透明度为0
      opacity: 0;
      //max-width: 100%; 
      //overflow-x: auto;
      .extra-button
      {
        width:24px;
        height:24px;
        max-width: 30px;
        padding-left: 5px;
        background-color: inherit;
        border: 0px;
        margin-top:0px;
        margin-bottom: 2px;
      }
      .extra-button:hover {
        //background-color: #f0f0f0; /* 背景颜色变化 */
        @include background_color("more-button-color-hover");
        //border-color: #ccc; /* 边框颜色变化，如果有边框的话 */
      } 
      .el-icon-copy,
      .el-icon-copied,
      .el-icon-good,
      .el-icon-good-fill,
      .el-icon-bad,
      .el-icon-bad-fill{
        display: flex;
        width:16px;
        height:16px;
        background-size:100% 100%;
        margin-left: 2px;
      }
      .el-icon-copied{
        @include background_image("correct-img");
      }
      .el-icon-copy
      {
        @include background_image("copy-img");
        transform: translateY(3px); /* 调整此值以控制向下移动的距离 */
      }
      .el-icon-good
      {
        @include background_image("good-img");
        transform: translateX(3px);
      }
      .el-icon-good-fill
      {
        @include background_image("good-fill-img");
        transform: translateX(3px);
      }
      .el-icon-bad
      {
        @include background_image("bad-img");
        transform: translateX(3px);
      }
      .el-icon-bad-fill
      {
        @include background_image("bad-fill-img");
        transform: translateX(3px);
      }
    }
    .cmd-suggestion-warpper
    {
      margin-top: 20px;
    }
  }
}

// 调整markdown组件样式
.md-preview
{
  max-width: 100%;
  overflow-x: auto;
  border-radius: 10px;
  @include font_color("font-color");
  background-color: inherit;
  margin-bottom: 0px;
  /*::v-deep(.md-editor-preview-wrapper) 
  {
    max-width: 100%;
    padding-bottom: 0px;
    .github-theme p 
    {
      line-height: unset;
      margin-bottom: 0px;
      @include font_color("font-color");
    }
  }*/
  ::v-deep(.github-markdown-body)
  {
    padding-top: 10px;
    padding-bottom: 0px;
    padding-left: 20px;
    padding-right: 20px;
  }
}


</style>
